// extracted by mini-css-extract-plugin
module.exports = {"spinner":"HourGlass_spinner__eX_Nd","winetime":"HourGlass_winetime__7oWab"};